import { paymentClient } from "@core/clients";
import { CreateYooKassaPaymentInput } from "@core/types";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

type UseCreateYooKassaPaymentMutationParams = {
  options?: Omit<UseMutationOptions<unknown, unknown, CreateYooKassaPaymentInput, unknown>, "mutationFn">;
};

export default function useCreateYooKassaPaymentMutation({
  options = {},
}: UseCreateYooKassaPaymentMutationParams = {}) {
  return useMutation(
    ["create-YooKassa-payment"],
    async (input) => {
      return await paymentClient.createYooKassaPayment(input);
    },
    {
      ...options
    },
  );
}
